export const AUTH_SESSION_CHANGED = "auth-session-changed";

export function notifyAuthSessionChanged() {
  if (typeof window !== "undefined") window.dispatchEvent(new Event(AUTH_SESSION_CHANGED));
}

export function subscribeAuthSession(listener: () => void) {
  window.addEventListener("storage", listener);
  window.addEventListener("focus", listener);
  window.addEventListener(AUTH_SESSION_CHANGED, listener);
  return () => {
    window.removeEventListener("storage", listener);
    window.removeEventListener("focus", listener);
    window.removeEventListener(AUTH_SESSION_CHANGED, listener);
  };
}
